// @flow
import React from 'react';
import { Query, Mutation } from '@apollo/client/react/components';
import {
  GET_ASSIGNED_PERSONS,
  UPDATE_REASON_FOR_NO_ACCOUNTANT,
  GET_REASON_FOR_NO_ACCOUNTANT,
} from './queries';
import NoAccountantBanner from './NoAccountantBanner';

const accountantWithAccessRoleId = '2';
const accountantWithoutAccessRoleId = '3';

type NoAccountantBannerContainerProps = {
  clientId: string,
};

/** */
const NoAccountantBannerContainer = ({ clientId }: NoAccountantBannerContainerProps) => (
  <Mutation
    mutation={UPDATE_REASON_FOR_NO_ACCOUNTANT}
    refetchQueries={[{ query: GET_REASON_FOR_NO_ACCOUNTANT, variables: { clientId } }]}
  >
    {updateReasonForNoAccountant => (
      <Query query={GET_ASSIGNED_PERSONS} variables={{ clientId }}>
        {(getAssignedPersons: any) => {
          if (getAssignedPersons.error) {
            return 'Unable to determine whether this client has an accountant. Reload page to try again.';
          }

          if (getAssignedPersons.loading) {
            return null;
          }

          const attachedPersons = getAssignedPersons.data.client.attachedPersons || [];
          const hasAccountants = attachedPersons.some(
            person =>
              person.clientRoleIds.includes(accountantWithAccessRoleId) ||
              person.clientRoleIds.includes(accountantWithoutAccessRoleId),
          );

          if (hasAccountants) {
            return null;
          }

          return (
            <Query query={GET_REASON_FOR_NO_ACCOUNTANT} variables={{ clientId }}>
              {(getReasonForNoAccountant: any) => {
                if (getReasonForNoAccountant.error) {
                  return "Unable to fetch why this client doesn't have an accountant. Reload page to try again.";
                }

                if (getReasonForNoAccountant.loading) {
                  return null;
                }

                const reasonForNoAccountant =
                  getReasonForNoAccountant.data.client.reasonForNoAccountant || '';

                return (
                  <NoAccountantBanner
                    reasonForNoAccountant={reasonForNoAccountant}
                    onReasonSelect={reason =>
                      updateReasonForNoAccountant({
                        variables: {
                          clientId,
                          reason,
                        },
                      })
                    }
                  />
                );
              }}
            </Query>
          );
        }}
      </Query>
    )}
  </Mutation>
);

export default NoAccountantBannerContainer;
